import { Divider } from '@mui/material';

export const ListDivider = () => {
  return (
    <Divider
      aria-hidden='true'
      sx={{
        height: '1px',
        width: '100%',
        color: 'primary.shade_100',
        borderColor: 'primary.shade_100',
      }}
    />
  );
};
